module.exports = __webpack_public_path__ + "assets/redpack-d8ebf69a.png";